import { Category } from "@/../functions/src/models/Category";

export function buildCategoryFromFirestore(doc) {
  return Category.buildFromFirestore(doc);
}
